<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc">
<h2>Contents</h2>
<ol>
<li><a href="#/supernaturalepub#_idParaDest-1">Introduction</a></li>
<li><a href="#/supernaturalepub1#_idParaDest-2">The Dingus</a></li>
<li><a href="#/supernaturalepub2#_idParaDest-3">The Getaway</a></li>
<li><span href="#/supernaturalepub3#_idParaDest-4" title="Link target outside of Sample">Mortal Bait</span></li>
<li><span href="#/supernaturalepub4#_idParaDest-5" title="Link target outside of Sample">Little Shit</span></li>
<li><span href="#/supernaturalepub5#_idParaDest-6" title="Link target outside of Sample">Ditch Witch</span></li>
<li><span href="#/supernaturalepub6#_idParaDest-7" title="Link target outside of Sample">The Last Triangle</span></li>
<li><span href="#/supernaturalepub7#_idParaDest-8" title="Link target outside of Sample">The Carrion Gods in their Heaven</span></li>
<li><span href="#/supernaturalepub8#_idParaDest-9" title="Link target outside of Sample">The Romance</span></li>
<li><span href="#/supernaturalepub9#_idParaDest-10" title="Link target outside of Sample">Dead Sister</span></li>
<li><span href="#/supernaturalepub10#_idParaDest-11" title="Link target outside of Sample">Comfortable in Her Skin</span></li>
<li><span href="#/supernaturalepub11#_idParaDest-12" title="Link target outside of Sample">But For Scars</span></li>
<li><span href="#/supernaturalepub12#_idParaDest-13" title="Link target outside of Sample">The Absent Eye</span></li>
<li><span href="#/supernaturalepub13#_idParaDest-14" title="Link target outside of Sample">The Maltese Unicorn</span></li>
<li><span href="#/supernaturalepub14#_idParaDest-15" title="Link target outside of Sample">Dreamer of the Day</span></li>
<li><span href="#/supernaturalepub15#_idParaDest-16" title="Link target outside of Sample">In Paris, in the Mouth of Kronos</span></li>
<li><span href="#/supernaturalepub16#_idParaDest-17" title="Link target outside of Sample">About the Author</span></li>
</ol>
</nav>
<nav epub:type="landmarks">
<h2>Landmarks</h2>
<ol>
<li><a epub:type="cover" href="#/cover">Cover</a></li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?c55e872e